// import React, { useState, useEffect } from 'react';
// import { Col, Form, Modal, Row } from 'react-bootstrap';
// import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
// import Select from 'react-select';
// import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
// import deleteImg from '../../assets/images/Settings/deleteImage.svg';  // Assuming delete image
// import { useDispatch, useSelector } from 'react-redux';
// import { loadBranchDropdownData, loadSlocDropdownData, postUserManagementSlocDatas } from '../../redux/action';
// import * as HeaderAuthentication from '../HeaderAuthentication';

// const AddSlocModal = (props) => {
//     const dispatch = useDispatch();
//     const { singleUserData, userID, userManagenemtData } = props;
//     const { slocDropdown, branchDropdown } = useSelector((state) => state.data);

//     const [userName, setUserName] = useState("");
//     const [selectedBranch, setSelectedBranch] = useState(null);
//     const [selectedSloc, setSelectedSloc] = useState(null);
//     const [storageLocation, setStorageLocation] = useState([]);
//     const [errorMessage, setErrorMessage] = useState("");
//     const [filteredSlocs, setFilteredSlocs] = useState([]);

//     useEffect(() => {
//         if (singleUserData && singleUserData.length > 0) {
//             const user = singleUserData[0];
//             if (user && user.FirstName) {
//                 setUserName(user.FirstName);
//             }
//             setStorageLocation(user.UserSloc);
//         }
//     }, [singleUserData]);

//     useEffect(() => {
//         dispatch(loadSlocDropdownData());
//         dispatch(loadBranchDropdownData());
//     }, [dispatch]);

//     const handleBranchChange = (branch) => {
//         console.log("Selected Branch:", branch);
//         setSelectedBranch(branch);
//         setErrorMessage(""); // Clear error message when branch is changed

//         if (branch && branch.BranchCode) {
//             // Filter Slocs based on ReportingToCode
//             const filteredSlocs = slocDropdown.filter(sloc => sloc.ReportingToCode === branch.BranchCode);
//             setFilteredSlocs(filteredSlocs); // Store filtered slocs in state
//         }
//     };

//     const handleSlocChange = (sloc) => {
//         setSelectedSloc(sloc);
//         setErrorMessage(""); // Clear error message when sloc is changed
//     };

//     const handleAddStorage = () => {
//         if (selectedBranch && selectedSloc) {
//             if (selectedBranch.value === selectedSloc.value) {
//                 setErrorMessage("Branch and Sloc cannot be the same.");
//                 return;
//             }

//             const isDuplicate = storageLocation.some(
//                 (location) =>
//                     location.BranchID === selectedBranch.value &&
//                     location.CustSlocID === selectedSloc.value
//             );

//             if (isDuplicate) {
//                 setErrorMessage("This Branch-Sloc combination already exists.");
//                 return;
//             }

//             setErrorMessage(""); // Clear error if no issues

//             const newStorageLocation = {
//                 BranchID: selectedBranch.value,
//                 BranchName: selectedBranch.label,
//                 CustSlocID: selectedSloc.value,
//                 StorageLocationName: selectedSloc.label,
//             };

//             setStorageLocation([...storageLocation, newStorageLocation]);
//             setSelectedBranch(null);
//             setSelectedSloc(null);
//         } else {
//             alert("Please select both Branch and Sloc");
//         }
//     };

//     const handleRemoveStorage = (index) => {
//         const updatedStorageLocation = [...storageLocation];
//         updatedStorageLocation.splice(index, 1);
//         setStorageLocation(updatedStorageLocation);
//     };

//     const AddUserManagementSlocData = (e) => {
//         e.preventDefault();

//         if (storageLocation.length === 0) {
//             setErrorMessage("No storage locations added. Please add a storage location before saving.");
//             return;
//         } else {
//             setErrorMessage("");
//         }

//         const slocData = {
//             UserID: userID,
//             UserSloc: storageLocation.map(location => ({
//                 BranchID: location.BranchID,
//                 CustSlocID: location.CustSlocID,
//             })),
//         };

//         const requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(slocData),
//         };

//         dispatch(postUserManagementSlocDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
//     };

//     return (
//         <Modal show={props.openSlocModal} onHide={props.handleCloseSlocModal} className="add-customer-modal">
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Storage Locations</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className="customer-form-fields customer-branch-plant-form-fields">
//                     <Col>
//                         <Row>
//                             <Col md={12}>
//                                 <div>
//                                     <label>Username</label>
//                                     <Form.Control
//                                         type="text"
//                                         value={userName}
//                                         onChange={(e) => setUserName(e.target.value)}
//                                         placeholder="Enter Username"
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>
//                         <div className="wq-modal-table-container">
//                             <Row>
//                                 <Col md={6}>
//                                     <div>
//                                         <label>Plant</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             value={selectedBranch ? { value: selectedBranch.value, label: selectedBranch.label } : null}
//                                             onChange={handleBranchChange}
//                                             options={branchDropdown}
//                                             placeholder="Select Plant"
//                                         />
//                                     </div>
//                                 </Col>
//                                 <Col md={6}>
//                                     <div>
//                                         <label>Sloc</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             value={selectedSloc ? { value: selectedSloc.value, label: selectedSloc.label } : null}
//                                             onChange={handleSlocChange}
//                                             // options={slocDropdown}
//                                             options={filteredSlocs}
//                                             placeholder="Select Sloc"
//                                         />
//                                     </div>
//                                 </Col>
//                             </Row>

//                             {/* Display Error Message */}
//                             {errorMessage && (
//                                 <Row>
//                                     <Col md={12} className="text-danger text-center">
//                                         {errorMessage}
//                                     </Col>
//                                 </Row>
//                             )}

//                             <Row>
//                                 <Col className="d-flex justify-content-center pt-4">
//                                     <SbAddBtn btnName="Add Storage Location" onClickEffect={handleAddStorage} />
//                                 </Col>
//                             </Row>

//                             <Row className="add-sloc-table-div">
//                                 <TableContainer
//                                     component={Paper}
//                                     sx={{ maxHeight: 440 }}
//                                     className="table-container add-sloc-table-container"
//                                     style={{ boxShadow: "none" }}
//                                 >
//                                     <Table stickyHeader>
//                                         <TableHead>
//                                             <TableRow>
//                                                 <TableCell className="table-header-div">Plant</TableCell>
//                                                 <TableCell className="table-header-div">Sloc</TableCell>
//                                                 <TableCell className="table-header-div">Action</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             {storageLocation.map((location, index) => (
//                                                 <TableRow key={index}>
//                                                     <TableCell>{location.BranchName}</TableCell>
//                                                     <TableCell>
//                                                         {location.StorageLocationName}
//                                                         {location.Status === "Inactive" && (
//                                                             <span style={{ color: "red", fontStyle: "italic" }}> (Inactive)</span>
//                                                         )}
//                                                     </TableCell>
//                                                     <TableCell>
//                                                         <img
//                                                             src={deleteImg}
//                                                             alt="Delete"
//                                                             onClick={() => handleRemoveStorage(index)}
//                                                             style={{ cursor: "pointer" }}
//                                                         />
//                                                     </TableCell>
//                                                 </TableRow>
//                                             ))}
//                                         </TableBody>
//                                     </Table>
//                                 </TableContainer>
//                             </Row>
//                         </div>
//                     </Col>
//                 </Row>
//             </Modal.Body>
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseSlocModal} />
//                 <SBSaveUpdateBtn btnName="Save" onClickEffect={AddUserManagementSlocData} />
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default AddSlocModal;







// import React, { useState, useEffect } from 'react';
// import { Col, Form, Modal, Row } from 'react-bootstrap';
// import SbCancelBtn, { SbAddBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
// import { MultiSelect } from "react-multi-select-component";
// import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
// import deleteImg from '../../assets/images/Settings/deleteImage.svg';
// import { useDispatch, useSelector } from 'react-redux';
// import { loadBranchDropdownData, loadSlocDropdownData, postUserManagementPlantDatas, postUserManagementSlocDatas } from '../../redux/action';
// import * as HeaderAuthentication from '../HeaderAuthentication';
// import noDataFound from '../../assets/images/no-data-found.svg'
// import { Tabs, Tab, Box } from '@mui/material';

// const AddSlocModal = (props) => {
//     const dispatch = useDispatch();
//     const { singleUserData, userID, userManagenemtData } = props;
//     const { slocDropdown, branchDropdown } = useSelector((state) => state.data);
//     const [userName, setUserName] = useState("");
//     const [selectedBranches, setSelectedBranches] = useState([]);
//     const [selectedSlocs, setSelectedSlocs] = useState([]);
//     const [storageLocation, setStorageLocation] = useState([]);
//     const [errorMessage, setErrorMessage] = useState("");
//     const [filteredSlocs, setFilteredSlocs] = useState([]);
//     const [activeTab, setActiveTab] = useState(0);

//     const handleTabChange = (event, newValue) => {
//         setActiveTab(newValue);
//     };

//     useEffect(() => {
//         // dispatch(loadSlocDropdownData());
//         dispatch(loadBranchDropdownData());
//     }, [dispatch]);

//     // useEffect(() => {
//     //     // if (props.openSlocModal) {
//     //     if (userID && singleUserData && singleUserData.length > 0) {
//     //         const user = singleUserData[0];
//     //         setUserName(user?.FirstName || "");

//     //         // Set the selected Plants (Branches)
//     //         const userPlants = user.UserPlant || [];
//     //         const selectedPlantOptions = userPlants.map(plant => {
//     //             const branch = branchDropdown.find(b => b.value === plant.BranchID);
//     //             return branch ? { value: branch.value, label: branch.label } : null;
//     //         }).filter(Boolean);

//     //         setSelectedBranches(selectedPlantOptions);
//     //         dispatch(loadSlocDropdownData(selectedPlantOptions.value));
//     //         // Set the selected SLOCs
//     //         const userSlocs = user.UserSloc || [];
//     //         const selectedSlocOptions = userSlocs.map(sloc => {
//     //             const slocOption = slocDropdown.find(s => s.value === sloc.CustSlocID);
//     //             return slocOption ? {
//     //                 value: slocOption.value,
//     //                 label: slocOption.label,
//     //                 BranchID: sloc.BranchID // Use BranchID here instead of ReportingToCode
//     //             } : null;
//     //         }).filter(Boolean);

//     //         setSelectedSlocs(selectedSlocOptions);

//     //         // Set Storage Location (for SLOC tab display)
//     //         const updatedStorage = selectedSlocOptions.map(sloc => {
//     //             const branch = branchDropdown.find(branch => branch.value === sloc.BranchID);
//     //             return {
//     //                 BranchID: sloc.BranchID, // Use BranchID directly
//     //                 BranchName: branch ? branch.label : "Unknown",
//     //                 CustSlocID: sloc.value,
//     //                 StorageLocationName: sloc.label
//     //             };
//     //         });

//     //         setStorageLocation(updatedStorage);
//     //     }
//     //     // }
//     // }, [userID, singleUserData]);

//     useEffect(() => {
//         if (
//             userID &&
//             singleUserData &&
//             singleUserData.length > 0 &&
//             branchDropdown.length > 0
//         ) {
//             const user = singleUserData[0];
//             setUserName(user?.FirstName || "");

//             const userPlants = user.UserPlant || [];

//             const selectedPlantOptions = userPlants.map((plant) => {
//                 const branch = branchDropdown.find((b) => b.value === plant.BranchID);
//                 return branch ? { value: branch.value, label: branch.label } : null;
//             }).filter(Boolean);

//             setSelectedBranches(selectedPlantOptions);

//             const selectedBranchIDs = selectedPlantOptions.map((b) => b.value);
//             if (selectedBranchIDs.length > 0) {
//                 dispatch(loadSlocDropdownData(selectedBranchIDs));
//             } else {
//                 dispatch(loadSlocDropdownData());
//             }
//         }
//     }, [userID, singleUserData, branchDropdown]);

//     useEffect(() => {
//         if (
//             userID &&
//             singleUserData &&
//             singleUserData.length > 0 &&
//             selectedBranches.length > 0 &&
//             slocDropdown.length > 0
//         ) {
//             const user = singleUserData[0];

//             const userSlocs = user.UserSloc || [];
//             const selectedSlocOptions = userSlocs.map((sloc) => {
//                 const slocOption = slocDropdown.find((s) => s.value === sloc.CustSlocID);
//                 return slocOption
//                     ? {
//                         value: slocOption.value,
//                         label: slocOption.label,
//                         BranchID: sloc.BranchID,
//                     }
//                     : null;
//             }).filter(Boolean);

//             setSelectedSlocs(selectedSlocOptions);

//             const updatedStorage = selectedSlocOptions.map((sloc) => {
//                 const branch = branchDropdown.find((branch) => branch.value === sloc.BranchID);
//                 return {
//                     BranchID: sloc.BranchID,
//                     BranchName: branch ? branch.label : "Unknown",
//                     CustSlocID: sloc.value,
//                     StorageLocationName: sloc.label,
//                 };
//             });

//             setStorageLocation(updatedStorage);
//         }
//     }, [userID, singleUserData, slocDropdown, selectedBranches]);


//     // // Define the missing functions
//     // const handleBranchChange = (selected) => {
//     //     setSelectedBranches(selected);
//     //     const selectedBranchCodes = selected.map(branch => branch.value);

//     //     // Load SLOCs based on selected branches
//     //     dispatch(loadSlocDropdownData(selectedBranchCodes));
//     // };

//     // // Modified handleSlocChange function to include Plant Name (Branch Name) correctly
//     // // Corrected handleSlocChange function
//     // const handleSlocChange = (selected) => {
//     //     setSelectedSlocs(selected);

//     //     // Automatically add selected SLOCs to storageLocation with correct Branch Name
//     //     const updatedStorage = selected.map(sloc => {
//     //         // Find the associated branch using ReportingToCode
//     //         const branch = branchDropdown.find(branch => branch.BranchCode === sloc.ReportingToCode);
//     //         return {
//     //             BranchID: branch ? branch.value : null, // Set correct BranchID
//     //             BranchName: branch ? branch.label : "Unknown", // Set correct Branch Name
//     //             CustSlocID: sloc.value,
//     //             StorageLocationName: sloc.label
//     //         };
//     //     });

//     //     setStorageLocation(prevStorage => {
//     //         // Prevent duplicates
//     //         const existingIds = prevStorage.map(loc => loc.CustSlocID);
//     //         const newLocations = updatedStorage.filter(loc => !existingIds.includes(loc.CustSlocID));
//     //         return [...prevStorage, ...newLocations];
//     //     });
//     // };

//     // Function to handle Branch Change (Plant)
//     const handleBranchChange = (selected) => {
//         setSelectedBranches(selected);
//         const selectedBranchCodes = selected.map(branch => branch.value);

//         // Load SLOCs based on selected branches
//         // dispatch(loadSlocDropdownData(selectedBranchCodes));

//         // Only load SLOCs now when user selects branch manually
//         if (selected.length > 0) {
//             const selectedBranchCodes = selected.map(branch => branch.value);
//             dispatch(loadSlocDropdownData(selectedBranchCodes));
//         }

//         // Remove SLOCs in storageLocation that belong to removed branches
//         setStorageLocation(prevStorage =>
//             prevStorage.filter(location => selectedBranchCodes.includes(location.BranchID))
//         );

//         // Remove SLOCs from selectedSlocs that belong to removed branches
//         setSelectedSlocs(prevSelectedSlocs =>
//             prevSelectedSlocs.filter(sloc => selectedBranchCodes.includes(sloc.BranchID))
//         );
//     };

//     // Function to handle SLOC Change
//     const handleSlocChange = (selected) => {
//         setSelectedSlocs(selected);
//         console.log(selected, 'selected')
//         // Automatically update storageLocation based on selected SLOCs
//         const updatedStorage = selected.map(sloc => {
//             const branch = branchDropdown.find(branch => branch.BranchCode === sloc.ReportingToCode);
//             return {
//                 BranchID: branch.value,
//                 BranchName: branch ? branch.label : "Unknown",
//                 CustSlocID: sloc.value,
//                 StorageLocationName: sloc.label
//             };
//         });

//         setStorageLocation(updatedStorage);
//     };


//     const handleRemoveStorage = (index) => {
//         setStorageLocation(prevStorage => prevStorage.filter((_, i) => i !== index));
//     };
//     console.log(storageLocation, 'storageLocation')
//     const AddUserManagementSlocData = (e) => {
//         e.preventDefault();

//         if (storageLocation.length === 0) {
//             setErrorMessage("No storage locations added. Please add a storage location before saving.");
//             return;
//         }

//         const slocData = {
//             UserID: userID, // Including UserID in the payload
//             UserSloc: storageLocation.map(location => ({
//                 BranchID: location.BranchID, // Directly use BranchID
//                 CustSlocID: location.CustSlocID
//             }))
//         };

//         const requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(slocData),
//         };

//         dispatch(postUserManagementSlocDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
//     };

//     const AddUserManagementPlantData = (e) => {
//         e.preventDefault();

//         if (selectedBranches.length === 0) {
//             setErrorMessage("No plants selected. Please add a plant before saving.");
//             return;
//         }

//         // Preparing Plant Data
//         const plantData = {
//             UserID: userID,
//             UserPlant: selectedBranches.map(branch => ({
//                 BranchID: branch.value,
//                 StatusID: 71
//             }))
//         };

//         const requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(plantData),
//         };

//         dispatch(postUserManagementPlantDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
//     };

//     const handleCloseSlocModal = () => {
//         setSelectedBranches([]);  // Reset selected branches
//         setSelectedSlocs([]);     // Reset selected slocs
//         setFilteredSlocs([]);     // Reset filtered slocs
//         setErrorMessage("");      // Clear error message
//         props.handleCloseSlocModal();  // Close the modal
//         props.setUserID("");
//     };

//     return (
//         <Modal show={props.openSlocModal} onHide={handleCloseSlocModal} className="add-customer-modal">
//             <Modal.Header closeButton>
//                 <Modal.Title>Add Storage Locations</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Row className="customer-form-fields customer-branch-plant-form-fields">
//                     <Col>
//                         <Row>
//                             <Col md={12}>
//                                 <div>
//                                     <label>Username</label>
//                                     <Form.Control
//                                         type="text"
//                                         value={userName}
//                                         onChange={(e) => setUserName(e.target.value)}
//                                         placeholder="Enter Username"
//                                         disabled
//                                     />
//                                 </div>
//                             </Col>
//                         </Row>

//                         <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: 2 }}>
//                             <Tabs value={activeTab} onChange={handleTabChange}>
//                                 <Tab label="Plant" />
//                                 <Tab label="Sloc" />
//                             </Tabs>
//                         </Box>

//                         {/* Plant Tab */}
//                         {activeTab === 0 && (
//                             <Box sx={{ mt: 2 }}>
//                                 <Col md={6}>
//                                     <div>
//                                         <label className='pt-1 pb-1'>Plant</label>
//                                         <MultiSelect
//                                             options={branchDropdown}
//                                             value={selectedBranches}
//                                             onChange={handleBranchChange}
//                                             labelledBy="Select Plant"
//                                         />
//                                     </div>
//                                 </Col>
//                             </Box>
//                         )}

//                         {/* Sloc Tab */}
//                         {activeTab === 1 && (
//                             <Box sx={{ mt: 2 }}>
//                                 <Col md={6}>
//                                     <div>
//                                         <label className='pt-1 pb-1'>Sloc</label>
//                                         <MultiSelect
//                                             options={slocDropdown}
//                                             value={selectedSlocs}
//                                             onChange={handleSlocChange}
//                                             labelledBy="Select Sloc"
//                                         />
//                                     </div>
//                                 </Col>
//                             </Box>
//                         )}

//                         {errorMessage && (
//                             <Row>
//                                 <Col md={12} className="text-danger text-center pt-2">
//                                     {errorMessage}
//                                 </Col>
//                             </Row>
//                         )}

//                         {/* Table remains unchanged */}
//                         <Row className="add-sloc-table-div pt-3">
//                             <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container add-sloc-table-container" style={{ boxShadow: "none" }}>
//                                 <Table stickyHeader>
//                                     <TableHead>
//                                         <TableRow>
//                                             <TableCell className="table-header-div">Plant</TableCell>
//                                             {activeTab === 1 && (
//                                                 <TableCell className="table-header-div">Sloc</TableCell>
//                                             )}
//                                             <TableCell className="table-header-div">Action</TableCell>
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody>
//                                         {activeTab === 0 ? (
//                                             // Display selected branches in Plant tab
//                                             selectedBranches.length > 0 ? (
//                                                 selectedBranches.map((branch, index) => (
//                                                     <TableRow key={index}>
//                                                         <TableCell>{branch.label}</TableCell>
//                                                         <TableCell>
//                                                             <img
//                                                                 src={deleteImg}
//                                                                 alt="Delete"
//                                                                 onClick={() => {
//                                                                     setSelectedBranches(prev => prev.filter((_, i) => i !== index));
//                                                                     setStorageLocation(prev => prev.filter(loc => loc.BranchID !== branch.value));
//                                                                 }}
//                                                                 style={{ cursor: "pointer" }}
//                                                             />
//                                                         </TableCell>
//                                                     </TableRow>
//                                                 ))
//                                             ) : (
//                                                 <TableRow>
//                                                     <TableCell colSpan={2} align="center">
//                                                         <img src={noDataFound} alt="No Data Found" style={{ height: "250px", width: "280px" }} />
//                                                     </TableCell>
//                                                 </TableRow>
//                                             )
//                                         ) : (
//                                             // Display selected SLOCs in Sloc tab
//                                             storageLocation.filter(loc => loc.CustSlocID).length > 0 ? (
//                                                 storageLocation.filter(loc => loc.CustSlocID).map((sloc, index) => (
//                                                     <TableRow key={index}>
//                                                         <TableCell>{sloc.BranchName || "N/A"}</TableCell>
//                                                         <TableCell>{sloc.StorageLocationName}</TableCell>
//                                                         <TableCell>
//                                                             <img
//                                                                 src={deleteImg}
//                                                                 alt="Delete"
//                                                                 onClick={() => {
//                                                                     setStorageLocation(prev => prev.filter((_, i) => i !== index));
//                                                                     setSelectedSlocs(prev => prev.filter(s => s.value !== sloc.CustSlocID));
//                                                                 }}
//                                                                 style={{ cursor: "pointer" }}
//                                                             />
//                                                         </TableCell>
//                                                     </TableRow>
//                                                 ))
//                                             ) : (
//                                                 <TableRow>
//                                                     <TableCell colSpan={3} align="center">
//                                                         <img src={noDataFound} alt="No Data Found" style={{ height: "250px", width: "280px" }} />
//                                                     </TableCell>
//                                                 </TableRow>)
//                                         )}
//                                     </TableBody>
//                                 </Table>
//                             </TableContainer>
//                         </Row>
//                     </Col>
//                 </Row>
//             </Modal.Body>
//             <Modal.Footer>
//                 <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseSlocModal} />
//                 <SBSaveUpdateBtn
//                     // btnName="Save" 
//                     btnName={activeTab === 0 ? "Save Plant" : "Save Sloc"}
//                     // onClickEffect={AddUserManagementSlocData} 
//                     onClickEffect={activeTab === 0 ? AddUserManagementPlantData : AddUserManagementSlocData}
//                 />
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default AddSlocModal;







import { useState, useEffect } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import SbCancelBtn, { SBSaveUpdateBtn } from '../Buttons/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { loadBranchDropdownData, loadSlocDropdownData, postUserManagementPlantDatas, postUserManagementSlocDatas } from '../../redux/action';
import * as HeaderAuthentication from '../HeaderAuthentication';
import { Tabs, Tab, Box } from '@mui/material';

const AddSlocModal = (props) => {
    const dispatch = useDispatch();
    const { singleUserData, userID, userManagenemtData } = props;
    const { slocDropdown, branchDropdown } = useSelector((state) => state.data);
    const [userName, setUserName] = useState("");
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedSlocs, setSelectedSlocs] = useState([]);
    const [storageLocation, setStorageLocation] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [filteredSlocs, setFilteredSlocs] = useState([]);
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        // dispatch(loadSlocDropdownData());
        dispatch(loadBranchDropdownData());
    }, [dispatch]);

    useEffect(() => {
        if (
            userID &&
            singleUserData &&
            singleUserData.length > 0 &&
            branchDropdown.length > 0
        ) {
            const user = singleUserData[0];
            setUserName(user?.FirstName || "");

            const userPlants = user.UserPlant || [];

            const selectedPlantOptions = userPlants.map((plant) => {
                const branch = branchDropdown.find((b) => b.value === plant.BranchID);
                return branch ? { value: branch.value, label: branch.label } : null;
            }).filter(Boolean);

            setSelectedBranches(selectedPlantOptions);

            const selectedBranchIDs = selectedPlantOptions.map((b) => b.value);
            if (selectedBranchIDs.length > 0) {
                dispatch(loadSlocDropdownData(selectedBranchIDs));
            } else {
                dispatch(loadSlocDropdownData());
            }
        }
    }, [userID, singleUserData, branchDropdown]);

    useEffect(() => {
        if (
            userID &&
            singleUserData &&
            singleUserData.length > 0 &&
            selectedBranches.length > 0 &&
            slocDropdown.length > 0
        ) {
            const user = singleUserData[0];

            const userSlocs = user.UserSloc || [];
            const selectedSlocOptions = userSlocs.map((sloc) => {
                const slocOption = slocDropdown.find((s) => s.value === sloc.CustSlocID);
                return slocOption
                    ? {
                        value: slocOption.value,
                        label: slocOption.label,
                        BranchID: sloc.BranchID,
                    }
                    : null;
            }).filter(Boolean);

            setSelectedSlocs(selectedSlocOptions);

            const updatedStorage = selectedSlocOptions.map((sloc) => {
                const branch = branchDropdown.find((branch) => branch.value === sloc.BranchID);
                return {
                    BranchID: sloc.BranchID,
                    BranchName: branch ? branch.label : "Unknown",
                    CustSlocID: sloc.value,
                    StorageLocationName: sloc.label,
                };
            });

            setStorageLocation(updatedStorage);
        }
    }, [userID, singleUserData, slocDropdown, selectedBranches]);

    // Function to handle Branch Change (Plant)
    const handleBranchChange = (selected) => {
        setSelectedBranches(selected);
        const selectedBranchCodes = selected.map(branch => branch.value);

        // Only load SLOCs now when user selects branch manually
        if (selected.length > 0) {
            const selectedBranchCodes = selected.map(branch => branch.value);
            dispatch(loadSlocDropdownData(selectedBranchCodes));
        }

        // Remove SLOCs in storageLocation that belong to removed branches
        setStorageLocation(prevStorage =>
            prevStorage.filter(location => selectedBranchCodes.includes(location.BranchID))
        );

        // Remove SLOCs from selectedSlocs that belong to removed branches
        setSelectedSlocs(prevSelectedSlocs =>
            prevSelectedSlocs.filter(sloc => selectedBranchCodes.includes(sloc.BranchID))
        );
    };

    const handleSlocCheckboxChange = (sloc, isChecked) => {
        // Try to find the BranchID from selectedBranches (based on ReportingToCode or some match)
        const matchingBranch = selectedBranches.find(branch =>
            sloc.ReportingToCode && branch.label.includes(sloc.ReportingToCode)
        );

        const branchID = matchingBranch ? matchingBranch.value : null;

        if (isChecked && branchID) {
            // Add to selectedSlocs
            const updatedSloc = { ...sloc, BranchID: branchID };
            setSelectedSlocs((prev) => [...prev, updatedSloc]);

            // Add to storageLocation
            const branch = branchDropdown.find((b) => b.value === branchID);
            const newStorage = {
                BranchID: branchID,
                BranchName: branch ? branch.label : "Unknown",
                CustSlocID: sloc.value,
                StorageLocationName: sloc.label,
            };
            setStorageLocation((prev) => [...prev, newStorage]);
        } else {
            // Remove from selectedSlocs
            setSelectedSlocs((prev) => prev.filter((item) => item.value !== sloc.value));

            // Remove from storageLocation
            setStorageLocation((prev) => prev.filter((item) => item.CustSlocID !== sloc.value));
        }
    };

    const AddUserManagementSlocData = (e) => {
        e.preventDefault();

        if (storageLocation.length === 0) {
            setErrorMessage("No storage locations added. Please add a storage location before saving.");
            return;
        }

        const slocData = {
            UserID: userID, // Including UserID in the payload
            UserSloc: storageLocation.map(location => ({
                BranchID: location.BranchID, // Directly use BranchID
                CustSlocID: location.CustSlocID
            }))
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(slocData),
        };

        dispatch(postUserManagementSlocDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
    };

    const AddUserManagementPlantData = (e) => {
        e.preventDefault();

        if (selectedBranches.length === 0) {
            setErrorMessage("No plants selected. Please add a plant before saving.");
            return;
        }

        // Preparing Plant Data
        const plantData = {
            UserID: userID,
            UserPlant: selectedBranches.map(branch => ({
                BranchID: branch.value,
                StatusID: 71
            }))
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(plantData),
        };

        dispatch(postUserManagementPlantDatas(requestOption, props.handleCloseSlocModal, userManagenemtData));
    };

    const handleCloseSlocModal = () => {
        setSelectedBranches([]);  // Reset selected branches
        setSelectedSlocs([]);     // Reset selected slocs
        setFilteredSlocs([]);     // Reset filtered slocs
        setErrorMessage("");      // Clear error message
        props.handleCloseSlocModal();  // Close the modal
        props.setUserID("");
    };

    // Group slocs by ReportingTo
    const groupedSlocs = slocDropdown.reduce((acc, sloc) => {
        const [reportingTo, code, name] = sloc.label.split(" - ");
        if (!acc[reportingTo]) acc[reportingTo] = [];
        acc[reportingTo].push({
            ...sloc,
            code,
            name,
            reportingTo,
        });
        return acc;

    }, {});

    return (
        <Modal show={props.openSlocModal} onHide={handleCloseSlocModal} className="add-customer-modal">
            <Modal.Header closeButton>
                <Modal.Title>Add Storage Locations</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="customer-form-fields customer-branch-plant-form-fields">
                    <Col>
                        <Row>
                            <Col md={12}>
                                <div>
                                    <label>Username</label>
                                    <Form.Control
                                        type="text"
                                        value={userName}
                                        onChange={(e) => setUserName(e.target.value)}
                                        placeholder="Enter Username"
                                        disabled
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: 2 }}>
                            <Tabs value={activeTab} onChange={handleTabChange}>
                                <Tab label="Plant" />
                                <Tab label="Sloc" />
                            </Tabs>
                        </Box>

                        {/* Plant Tab */}
                        {activeTab === 0 && (
                            <Box sx={{ mt: 2 }}>
                                <Col md={12}>
                                    <div>
                                        <label className='pt-1 pb-1'>Plant</label>
                                        <div className="p-2" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                            {branchDropdown.map((branch) => (
                                                <div key={branch.value} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`branch-${branch.value}`}
                                                        checked={selectedBranches.some((item) => item.value === branch.value)}
                                                        onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            const updated = isChecked
                                                                ? [...selectedBranches, branch]
                                                                : selectedBranches.filter((item) => item.value !== branch.value);
                                                            handleBranchChange(updated);
                                                        }}
                                                    />
                                                    <label className="form-check-label p-0" htmlFor={`branch-${branch.value}`}>
                                                        {branch.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Col>
                            </Box>
                        )}


                        {/* Sloc Tab */}
                        {activeTab === 1 && (
                            <Box sx={{ mt: 2 }}>
                                <Col md={12}>
                                    <div>
                                        <label className='pt-1 pb-1'>Sloc</label>
                                        <div className="p-2" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                            {/* {slocDropdown.map((sloc) => (
                                                <div key={sloc.value} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`sloc-${sloc.value}`}
                                                        checked={selectedSlocs.some((item) => item.value === sloc.value)}
                                                        onChange={(e) => handleSlocCheckboxChange(sloc, e.target.checked)}
                                                    />
                                                    <label className="form-check-label p-0" htmlFor={`sloc-${sloc.value}`}>
                                                        {sloc.label}
                                                    </label>
                                                </div>
                                            ))} */}
                                            {Object.entries(groupedSlocs).map(([reportingTo, slocs]) => (
                                                <div key={reportingTo}>
                                                    <div className="form-check ps-0">
                                                        <label className="form-check-label fw-bold">
                                                            <strong>{reportingTo}</strong>
                                                        </label>
                                                    </div>

                                                    <div className="ms-4">
                                                        {slocs.map((sloc) => (
                                                            <div key={sloc.value} className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`sloc-${sloc.value}`}
                                                                    checked={selectedSlocs.some((item) => item.value === sloc.value)}
                                                                    onChange={(e) => handleSlocCheckboxChange(sloc, e.target.checked)}
                                                                />
                                                                <label className="form-check-label p-0" htmlFor={`sloc-${sloc.value}`}>
                                                                    {sloc.code} - {sloc.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Col>
                            </Box>
                        )}

                        {errorMessage && (
                            <Row>
                                <Col md={12} className="text-danger text-center pt-2">
                                    {errorMessage}
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseSlocModal} />
                <SBSaveUpdateBtn
                    // btnName="Save" 
                    btnName={activeTab === 0 ? "Save Plant" : "Save Sloc"}
                    // onClickEffect={AddUserManagementSlocData} 
                    onClickEffect={activeTab === 0 ? AddUserManagementPlantData : AddUserManagementSlocData}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default AddSlocModal;




